export default __webpack_public_path__ + "static/media/CBM_BlackWhite.cddc25a2.png";